import "../App.css";

interface SelectProps {
  label: string;
  value: number;
  current: number;
  onSelect: (value: number) => void;
}

export const Select: React.FC<SelectProps> = ({
  label,
  value,
  current,
  onSelect,
}) => {
  return (
    <div
      className="button-tertiary-m button-text-s text-color-black white-fill"
      onClick={() => onSelect(value)}
      style={{
        border: `4px solid ${current === value ? "#F42272" : "transparent"}`,
        padding: "5px 12px",
        display: "flex",
        alignItems: "start",
        cursor: "pointer",
      }}
    >
      {label}
    </div>
  );
};

export default Select;
